import React, { Dispatch, SetStateAction, useContext } from 'react'
import { Vector3 } from 'three'

import { HtmlOverlayEntry } from './objects/HTMLOverlay'

type MapVizContextType = {
  // The third value is a counter that is active while the viewport is animating
  viewportSizeDuringAnimation: React.RefObject<Vector3>
  htmlOverlaysRef: { current: ReadonlyArray<HtmlOverlayEntry> }
  setHtmlOverlays: Dispatch<SetStateAction<HtmlOverlayEntry[]>>
}

const MapVizContext = React.createContext<MapVizContextType | undefined>(
  undefined
)

export const MapVizInternalProvider: React.FC<{
  value: MapVizContextType
  children: React.ReactNode
}> = ({ value, children }) => (
  <MapVizContext.Provider value={value}>{children}</MapVizContext.Provider>
)

export const useMapVizInternal = () => {
  const context = useContext(MapVizContext)
  if (!context)
    throw new Error('useMapViz() must be used within Site View MapViz')
  return context
}
